<template>
    <div>
        <div v-if="success" class="status-card success">
            <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>check-bold</title>
                <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
            </svg>
            <span>{{ message }}</span>
        </div>

        <div v-else class="status-card error">
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                    <circle cx="12" cy="12" r="10" />
                </svg>
                <span>{{ message }}</span>
            </div>

            <div class="status-card-actions">
                <div v-if="linkText" class="request-link-box">
                    <a :href="linkUrl">{{ linkText }}</a>
                </div>
                <div v-if="skipText" class="skip-link-box">
                    <a href="#" @click.prevent="$emit('skip')">{{ skipText }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatusCard',
    props: {
        success: { type: Boolean, required: true },
        message: { type: String, required: true },
        linkText: { type: String, default: '' },
        linkUrl: { type: String, default: '' },
        skipText: { type: String, default: '' },
    },
    computed: {},
};
</script>

<style>
.status-card {
    display: flex;
    align-items: center;
    padding: 20px 15px;
    margin: 0px auto;
    max-width: 500px;
    border-radius: 1px;
    font-family: Arial, sans-serif;
    font-size: 16px;
    background-color: #ffffff;
    color: #1a1a1a;
    box-shadow: 4px 4px 3px #010101;
    font-weight: 600;
}

.status-card .icon {
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    margin-right: 10px;
    vertical-align: middle;
}

.status-card.success {
    border: 1px solid #2bb65d;

    svg {
        fill: #2bb65d;
    }
}

.status-card.success .icon {
    stroke: #2bb65d;
}

.status-card.error {
    border: 2px solid #a60000;
    justify-content: space-between;
    align-items: center;

    .status-card-actions {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 6px;
    }

    .request-link-box {
        margin-bottom: -50px;

        a {
            text-decoration: none;
            font-size: 13px;
            color: #a60000;
        }
    }

    .skip-link-box {
        margin-bottom: -50px;

        a {
            text-decoration: underline;
            font-size: 12px;
            color: #5a3e8a;
            font-weight: 600;

            &:hover {
                color: #3e2a63;
            }
        }
    }
}

.status-card.error .icon {
    stroke: #a60000;
}
</style>
